module.exports = __webpack_public_path__ + "img/img-angle-image-overlay.7d9ff226.svg";